export default __webpack_public_path__ + "static/media/Group 9361 (1).19ddeb4f.png";